import { createPortal } from "react-dom"
import { Loader2 } from "lucide-react"

type Props = {
  label: string
}

// Full-screen overlay for slow actions that swap the whole session (logout,
// switch back) — blocks further clicks on the stale UI until it resolves.
const BlockingLoader = ({ label }: Props) =>
  createPortal(
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-white/70 backdrop-blur-sm"
    >
      <div className="flex items-center gap-3 rounded-md bg-white px-5 py-3 text-sm text-gray-700 shadow-lg ring-1 ring-black ring-opacity-5">
        <Loader2 className="h-5 w-5 animate-spin text-indigo-600" />
        {label}
      </div>
    </div>,
    document.body
  )

export default BlockingLoader
